<template>
  <div class="edit-predicted-expense-wo-actual">
    <colored-line-popup :class="'danger'" :close-action="closeAction">

      <template v-slot:top-content>
        <div class="expense-title">
          <span class="name">צפי הוצאה קבועה</span>
          • <span class="expense">{{ selectedExpenseCategory }}</span>
        </div>
        <transaction-amount :amount="predictedTransaction.predictedAmount" :class="'fixed'"/>
        <prediction-details :predicted-transaction="predictedTransaction" />
      </template>
      <template v-slot:bottom-content>
        <div class="question">איזו הוצאה קבועה זו?</div>
        <plain-dropdown :options="fixedExpenseCategories"
                        :selected="selectedExpenseCategory"
                        :on-select="onSelection"
                        :on-drop-down-change="onDropdownOpened"/>
        <riseup-button :action="onSave"
                       :variant="'secondary-black'"
                       :title="'שמירה'" />
      </template>
      <template v-slot:footer>
        <div class="cancel" v-on:click="onCancelPredictedTransaction">
          <img class="trash" :src="require('@/assets/icons/redtrash.svg')">
          <span class="text">מחיקת צפי הוצאה</span>
        </div>
      </template>

    </colored-line-popup>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import Segment from '../../../../../../../../../../../Segment';
import TransactionAmount from '../TransactionAmount.vue';
import PredictionDetails from '../PredictionDetails.vue';

export default {
  name: 'EditPredictedExpenseWOActual',
  components: {
    ColoredLinePopup: BaseUI.ColoredLinePopup,
    PlainDropdown: BaseUI.PlainDropdown,
    RiseupButton: BaseUI.RiseupButton,
    TransactionAmount,
    PredictionDetails,
  },
  props: {
    predictedTransaction: {
      type: Object,
      required: true,
    },
    fixedExpenseCategories: {
      type: Array,
      required: true,
    },
    closeAction: {
      type: Function,
      required: true,
    },
    cancelPrediction: {
      type: Function,
      required: true,
    },
    changeExpenseCategory: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedExpenseCategory: null,
      dropdownOpened: true,
    };
  },
  created() {
    Segment.trackUserInteraction('EditPredictedExpenseWOActual_Shown', {
      predictedTransaction: this.predictedTransaction,
    });
    this.selectedExpenseCategory = this.predictedTransaction.expense;
  },
  methods: {
    onSelection(expenseCategory) {
      this.selectedExpenseCategory = expenseCategory;
    },
    onSave() {
      Segment.trackUserInteraction('EditPredictedExpenseWOActual_SaveClicked', {
        predictedTransaction: this.predictedTransaction,
      });
      this.changeExpenseCategory(this.selectedExpenseCategory);
    },
    onCancelPredictedTransaction() {
      Segment.trackUserInteraction('EditPredictedExpenseWOActual_CancelPredictionClicked', {
        predictedTransaction: this.predictedTransaction,
      });
      this.cancelPrediction();
    },
    onDropdownOpened(isOpen) {
      this.dropdownOpened = isOpen;
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .edit-predicted-expense-wo-actual {
    text-align: right;

    .expense-title {
      font-weight: bold;
      color: $riseup_coral;
      margin-bottom: 24px;
      line-height: 10px;

      .expense {
        font-weight: normal;
      }
    }

    .transaction-amount {
      margin-bottom: 12px;
    }

    .bottom {
      .question {
        color: $riseup_black;
        line-height: 13px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      .plain-dropdown {
        margin-bottom: 40px;
      }

      .riseup-button {
        width: 100%;
      }
    }

    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      color: $riseup_coral;
      cursor: pointer;

      .trash {
        margin-left: 3px;
        height: 16px;
      }

      .text {
        text-decoration: underline;
      }
    }
  }

</style>
